import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import FadeIn from "./FadeIn";
import { useLang } from "@/i18n/LanguageContext";

export const Faq = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <FadeIn className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-signal">
                {t.faq.eyebrow}
              </p>
              <h2 className="mt-4 font-display text-2xl font-bold leading-tight text-ink sm:text-3xl lg:text-4xl">
                {t.faq.title}
              </h2>
            </div>
          </FadeIn>

          <div className="lg:col-span-7">
            {t.faq.items.map((item, i) => {
              const isOpen = open === i;
              return (
                <FadeIn key={i} delay={0.05 * i}>
                  <div
                    data-testid={`faq-item-${i}`}
                    className={`border-b border-white/8 transition-colors ${isOpen ? "border-signal/30" : ""}`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      data-testid={`faq-toggle-${i}`}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-6 py-6 text-left"
                    >
                      <span className="flex items-baseline gap-4">
                        <span className="font-mono text-xs text-signal">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className={`text-base font-semibold sm:text-lg ${isOpen ? "text-signal" : "text-ink"}`}>
                          {item.q}
                        </span>
                      </span>
                      <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3 }}>
                        <Plus size={20} className={isOpen ? "text-signal" : "text-ink-subtle"} />
                      </motion.span>
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                          className="overflow-hidden"
                        >
                          <p className="max-w-xl pb-7 pl-10 text-sm leading-relaxed text-ink-muted sm:text-base">
                            {item.a}
                          </p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                </FadeIn>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
